"use client";
import ToolTip from "@stadium/ui/src/components/tooltip/tippy-tooltip";

import { useFlags } from "@stadium/services/launch-darkly";

import { LinkButton } from "@stadium/shared/src/components/shared/button";

import { getMyPointsWalletRoute } from "@stadium/helpers/routes";

import { SNACKMAGIC, SUPERIORDISHES, SWAGMAGIC } from "@stadium/shared/src/constants/brands";
import { workspaceWalletFlag } from "@stadium/services/launch-darkly/constants";

import styles from "./main.module.scss";

const REWARD_POINTS_COLOR_STYLE = {
  [SNACKMAGIC]: styles.snackmagicTextClr,
  [SWAGMAGIC]: styles.swagmagicTextClr,
  [SUPERIORDISHES]: styles.superiorDishesTextClr,
};

const UserRewardPoints = ({ points = "", site = "", onClick = null }) => {
  const { [workspaceWalletFlag]: workspaceWalletFlagEnabled } = useFlags();

  const rewardPtsTextClr = REWARD_POINTS_COLOR_STYLE[site];
  const pointsWalletRoute = getMyPointsWalletRoute(workspaceWalletFlagEnabled);

  return (
    <ToolTip
      className={styles.userPoints}
      arrow
      interactive
      isLightTheme
      placement="bottom-end"
      content="SEE POINTS HISTORY"
    >
      <span>
        <LinkButton
          className={`${styles.userPoints} ${rewardPtsTextClr}`}
          href={pointsWalletRoute}
          onClick={onClick}
          target="_blank"
          styleType="link"
        >
          {points} PTS
        </LinkButton>
      </span>
    </ToolTip>
  );
};

export default UserRewardPoints;
